import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';
import { AnalyzeClauseVarianceResponseDto } from '../models/workspaces.model';

@Injectable({
  providedIn: 'root',
})
export class VarianceAnalysisApiService extends ApiService {
  constructor() {
    super();
  }

  analyzeClauseVariance$(
    workspaceId: string,
    referenceDocumentGuid: string,
  ): Observable<AnalyzeClauseVarianceResponseDto> {
    return this.post(`/VarianceAnalysis/workspace-analysis`, {
      workspaceId,
      documentId: referenceDocumentGuid,
    });
  }
}

export const apiVarianceAnalysisProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiVarianceAnalysis.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiVarianceAnalysis.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiVarianceAnalysis.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiVarianceAnalysis.scopes.write],
  },
];
